import styled from "@emotion/styled";
export const StyledWhatsNewPageLayoutDesktopComponent = styled.div`
  .whats-new-page-content {
    font-size: 54px;
    text-align: center;

    .items-list-wrapper {
      display: flex;
      margin-top: 40px;
      justify-content: center;
    }
  }
`;
